export function target() {
  return (
    ['Banner', 'BannerWithMenu'].includes(this.module) &&
    (typeof this.data.swiperAutoplaySpeed === 'string' ||
      typeof this.data.titleWeight === 'number')
  );
}

export function migrate() {
  if (Number(this.data.swiperAutoplaySpeed)) {
    this.data.swiperAutoplaySpeed = Number(this.data.swiperAutoplaySpeed);
  } else {
    delete this.data.swiperAutoplaySpeed;
  }

  if (String(this.data.titleWeight)) {
    this.data.titleWeight = String(this.data.titleWeight);
  } else {
    delete this.data.titleWeight;
  }

  // TODO: Automate repeatable migrations
  this.data.banners = this.data.banners.map(
    ({ titleWeight, imageFilterBlur, ...banner }) => ({
      ...banner,
      imageFilterBlur: imageFilterBlur || 0,
      titleWeight: String(titleWeight),
    }),
  );
}
